








































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class BreathingSection extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any;
  @Prop({ default: false }) readonly disabled!: boolean;

  form: any = {
    pernapasan: "spontan",
    alat_bantu_napas: "",
    aliran_fio2: "", // legacy gabungan (record lama)
    aliran_lpm: "",
    fio2: "",
    spo2: null,
    rr: null,
    pergerakan_dada: "simetris",
    deviasi_trakea: "tidak_ada",
    deviasi_trakea_ket: "",
    wsd: "tidak_ada",
    wsd_lokasi: "",
    wsd_volume: null,
    suara_napas: ["vesikuler"],
    suara_napas_lain: "",
    irama_napas: "reguler"
  };

  suaraOptions = [
    { text: "Vesikuler", value: "vesikuler" },
    { text: "Ronchi", value: "ronchi" },
    { text: "Wheezing", value: "wheezing" },
    { text: "Lain-lain", value: "lain" }
  ];

  get spo2Alert(): boolean {
    return typeof this.form.spo2 === "number" && this.form.spo2 > 0 && this.form.spo2 < 90;
  }

  created() {
    if (this.value && typeof this.value === "object") {
      this.form = { ...this.form, ...this.value };
    }
    this.migrateLegacyAliran();
  }

  //  record lama menyimpan gabungan di aliran_fio2 — tampilkan di kolom Aliran agar tetap terlihat/teredit
  migrateLegacyAliran() {
    if (this.form.aliran_fio2 && !this.form.aliran_lpm && !this.form.fio2) {
      this.form.aliran_lpm = this.form.aliran_fio2;
    }
  }


  @Watch("form", { deep: true })
  onFormChange(val: any) { this.$emit("input", { ...val }); }

  syncFromValue(val: any) {
    if (!val) return;
    this.form = { ...this.form, ...val };
    if (!Array.isArray(this.form.suara_napas)) this.form.suara_napas = [];
    this.migrateLegacyAliran();
  }
}
